import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FlowButton from '../flow-button/FlowButton';
import './NavigateButton.scss';

class NavigateButton extends Component {
    render() {
        const {
            onBack, onContinue, disableBack, backTitle, nextTitle, disableNext
        } = this.props;
        return (
            <div className='fl-survey-back-continue-btn'>
                { onBack && <div className='survey-align-btn'>
                    <FlowButton
                        text={ backTitle }
                        disabled={ disableBack }
                        onClick={ onBack }
                        type='back' />
                </div> }
                { onContinue && <div className='survey-align-btn'>
                    <FlowButton
                        text={ nextTitle }
                        onClick={ onContinue }
                        disabled={ disableNext } />
                </div> }
                <div style={ { clear: 'both', float: 'none' } } />
            </div>
        );
    }
}

NavigateButton.propTypes = {
    disableBack: PropTypes.bool,
    onBack: PropTypes.func,
    onContinue: PropTypes.func,
    disableNext: PropTypes.bool,
    backTitle: PropTypes.string,
    nextTitle: PropTypes.string
};

NavigateButton.defaultProps = {
    disableBack: false,
    onBack: null,
    onContinue: null,
    disableNext: false,
    backTitle: '',
    nextTitle: ''
};

export default NavigateButton;
